var exports = {
  "CR": "MessageReactionsModal.module__modalRoot___dlMxTD" + " " + __webpack_require__(545076)["root"] + " " + __webpack_require__(545076)["default"],
  "jE": "MessageReactionsModal.module__modalContent___dlMxTD",
  "Ij": "MessageReactionsModal.module__modalLayout___dlMxTD",
  "pz": "MessageReactionsModal.module__sidebar___dlMxTD",
  "PC": "MessageReactionsModal.module__reactionFiltersPane___dlMxTD",
  "VG": "MessageReactionsModal.module__reactionListContainer___dlMxTD",
};

module.exports = exports;
